var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveMoreGiftsJa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6424 3.22785L9.18213 4.37298C11.6906 3.65727 17.7575 7.3861 18.0746 7.5865L22.5349 6.44137C22.2178 6.24097 16.1439 2.51214 13.6424 3.22785Z",
    fill: "#D69B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3952 6.65611C10.9789 5.00998 11.5215 3.19209 13.1844 2.71973C8.50569 3.92211 7.86447 3.88633 7.32895 4.96704C6.85685 5.92609 7.2444 6.99965 7.93494 7.80839C9.61196 9.76227 17.1656 8.23782 17.5602 8.15909L22.0205 7.01396C21.6189 7.08553 14.0652 8.60998 12.3952 6.65611Z",
    fill: "url(#paint0_linear_367_391)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1777 2.71963C13.6991 2.56934 14.3262 2.54786 15.0379 2.70532C18.0467 3.35661 22.5915 6.28385 22.8311 6.4413H22.5352C22.2181 6.24806 16.1442 2.51208 13.6427 3.22778C13.5159 3.26357 13.3961 3.31367 13.2904 3.37808C11.0426 4.69498 12.6421 7.00671 15.8412 7.27152C19.0402 7.52917 21.8728 7.03534 22.0278 7.01387C21.6332 7.09259 14.0796 8.61705 12.4026 6.66317C10.9792 5.00989 11.5147 3.19916 13.1777 2.71963Z",
    fill: "#FFC01A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8543 2.24692C28.812 2.25408 28.7768 2.26839 28.7345 2.27555C26.5713 2.8839 23.1397 6.99205 21.7798 8.78131L27.0081 10.2843C28.2906 8.59523 32.4972 3.47794 34.59 3.70696C34.752 3.72127 34.9 3.75706 35.0339 3.79285C29.3898 2.17535 29.4814 2.11094 28.8543 2.24692Z",
    fill: "#D69B00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4362 3.12798L30.2078 1.625C31.8496 2.09737 31.8074 4.58086 30.384 5.84051C28.6506 7.36496 24.6483 8.58166 22.4287 9.09697L27.6571 10.6C29.8414 10.0918 35.3798 8.49577 36.3452 6.43454C36.9089 5.21784 36.8173 3.52162 35.4362 3.12798Z",
    fill: "url(#paint1_linear_367_391)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2704 1.57444C30.9404 1.32395 31.9691 2.7482 31.1518 4.82375C30.1864 7.27862 22.8089 9.00347 22.4214 9.08935C22.5694 9.05357 25.3174 8.33786 28.1712 6.78478C31.032 5.23886 31.8141 2.48339 29.362 2.21142C29.2422 2.19711 29.1224 2.20426 28.9956 2.21858C26.4871 2.5979 22.0127 8.47385 21.7802 8.7816L21.5054 8.90327C21.6815 8.66709 24.9862 4.14383 27.5581 2.31878C28.1712 1.88935 28.756 1.65317 29.2704 1.57444Z",
    fill: "#FDB400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6408 36.0003L10.3591 34.848L7.80127 10.0631L22.9579 7.85156L22.6408 36.0003Z",
    fill: "#BF253E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0221 9.79113L33.5835 34.7836L22.6406 36.0003L22.9577 7.85156L37.0221 9.79113Z",
    fill: "#E83350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.053 7.65806C14.0718 4.34435 15.8052 1.3026 16.4112 0.908958C17.0806 0.479535 23.8662 -0.672751 26.1774 0.536791C28.4885 1.75349 25.3811 7.25011 25.3811 7.25011L18.053 7.65806Z",
    fill: "url(#paint2_linear_367_391)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1477 8.71698L30.5612 35.0836L27.4326 35.4557L29.6592 7.95117L34.1477 8.71698Z",
    fill: "url(#paint3_linear_367_391)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2329 8.69615L15.3973 7.9375L17.0672 35.4779L14.3121 35.2488L11.2329 8.69615Z",
    fill: "url(#paint4_linear_367_391)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 44,
    height: 12,
    rx: 5,
    fill: "#FFD03B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.225 23.175L6.255 23.815C6.41 23.8 6.58 23.78 6.7 23.77C6.905 23.75 7.525 23.72 7.73 23.705C7.42 23.985 6.765 24.55 6.32 24.845C6.06 24.875 5.71 24.915 5.445 24.945L5.5 25.55C6.005 25.46 6.56 25.385 7.02 25.35C6.835 25.52 6.655 25.83 6.655 26.14C6.655 26.97 7.4 27.36 8.685 27.305L8.815 26.645C8.63 26.66 8.335 26.665 8.055 26.635C7.605 26.585 7.295 26.43 7.295 26.035C7.295 25.625 7.68 25.3 8.135 25.235C8.44 25.195 8.945 25.195 9.425 25.225L9.42 24.635C8.815 24.635 7.985 24.685 7.315 24.755C7.655 24.485 8.145 24.075 8.505 23.79C8.605 23.705 8.795 23.58 8.9 23.515L8.505 23.055C8.435 23.075 8.32 23.1 8.155 23.115C7.85 23.15 6.915 23.195 6.7 23.195C6.53 23.195 6.385 23.19 6.225 23.175ZM12.955 23.575L12.27 23.555C12.22 24.08 12.11 24.655 11.965 25.125C11.755 25.8 11.565 26.12 11.35 26.12C11.16 26.12 10.96 25.875 10.96 25.37C10.96 24.74 11.54 23.875 12.6 23.875C13.465 23.875 13.955 24.435 13.955 25.22C13.955 25.955 13.455 26.41 12.82 26.565C12.685 26.595 12.545 26.62 12.35 26.645L12.73 27.235C13.99 27.04 14.635 26.295 14.635 25.245C14.635 24.15 13.85 23.29 12.615 23.29C11.32 23.29 10.315 24.28 10.315 25.43C10.315 26.275 10.775 26.89 11.335 26.89C11.88 26.89 12.31 26.27 12.61 25.26C12.785 24.67 12.885 24.085 12.955 23.575ZM18.035 22.775V26.26H18.595V22.775H18.035ZM16.345 24.735L16.575 25.265L19.54 24.1L19.315 23.58L16.345 24.735ZM16.955 23.315V26.49C16.955 27.185 17.155 27.375 17.88 27.375C18.035 27.375 18.815 27.375 18.985 27.375C19.615 27.375 19.795 27.13 19.875 26.38C19.705 26.34 19.465 26.24 19.33 26.145C19.285 26.715 19.23 26.835 18.94 26.835C18.765 26.835 18.08 26.835 17.93 26.835C17.6 26.835 17.55 26.79 17.55 26.49V23.315H16.955ZM19.11 23.68C19.11 24.73 19.105 25.23 19.085 25.34C19.06 25.44 19.025 25.455 18.955 25.455C18.9 25.455 18.755 25.455 18.65 25.45C18.715 25.58 18.77 25.83 18.78 26C18.96 26.005 19.195 25.995 19.345 25.93C19.515 25.855 19.605 25.725 19.63 25.47C19.66 25.255 19.665 24.65 19.67 23.775L19.695 23.685L19.285 23.525L19.18 23.605L19.075 23.68H19.11ZM16.205 22.775C15.95 23.49 15.52 24.2 15.065 24.655C15.165 24.8 15.325 25.125 15.38 25.265C15.92 24.695 16.44 23.795 16.76 22.95L16.205 22.775ZM15.7 24.155V27.445H16.29V23.575V23.57L15.7 24.155ZM22.955 23.575L22.27 23.555C22.22 24.08 22.11 24.655 21.965 25.125C21.755 25.8 21.565 26.12 21.35 26.12C21.16 26.12 20.96 25.875 20.96 25.37C20.96 24.74 21.54 23.875 22.6 23.875C23.465 23.875 23.955 24.435 23.955 25.22C23.955 25.955 23.455 26.41 22.82 26.565C22.685 26.595 22.545 26.62 22.35 26.645L22.73 27.235C23.99 27.04 24.635 26.295 24.635 25.245C24.635 24.15 23.85 23.29 22.615 23.29C21.32 23.29 20.315 24.28 20.315 25.43C20.315 26.275 20.775 26.89 21.335 26.89C21.88 26.89 22.31 26.27 22.61 25.26C22.785 24.67 22.885 24.085 22.955 23.575ZM28.805 22.885L28.41 23.045C28.545 23.24 28.695 23.535 28.8 23.74L29.2 23.57C29.105 23.385 28.93 23.065 28.805 22.885ZM29.395 22.66L29 22.82C29.135 23.01 29.3 23.3 29.4 23.51L29.8 23.34C29.71 23.165 29.525 22.845 29.395 22.66ZM26.745 23.52C26.825 23.925 27.31 26.445 27.385 26.895C27.42 27.045 27.43 27.215 27.455 27.4L28.175 27.275C28.13 27.11 28.085 26.93 28.05 26.785C27.945 26.275 27.45 23.745 27.4 23.415C27.38 23.295 27.36 23.125 27.35 23.03L26.64 23.14C26.68 23.26 26.715 23.38 26.745 23.52ZM25.38 24.16L25.515 24.845C25.685 24.805 25.815 24.775 25.97 24.745C26.345 24.68 28.065 24.405 28.595 24.32C28.745 24.3 28.95 24.27 29.06 24.26L28.935 23.605C28.815 23.64 28.625 23.68 28.47 23.71C28.02 23.8 26.27 24.07 25.845 24.12C25.685 24.14 25.535 24.15 25.38 24.16ZM25.385 25.625L25.525 26.295C25.64 26.265 25.81 26.23 26.025 26.195C26.52 26.1 28.32 25.805 28.955 25.71C29.14 25.68 29.345 25.64 29.48 25.63L29.35 24.97C29.215 25.01 29.03 25.05 28.835 25.09C28.26 25.2 26.435 25.495 25.9 25.57C25.745 25.595 25.515 25.62 25.385 25.625ZM34.445 23.675L33.95 23.36C33.815 23.39 33.655 23.395 33.56 23.395C33.28 23.395 31.62 23.395 31.245 23.395C31.08 23.395 30.8 23.375 30.65 23.355V24.06C30.78 24.055 31.015 24.04 31.245 24.04C31.62 24.04 33.27 24.04 33.575 24.04C33.505 24.47 33.32 25.035 32.985 25.455C32.58 25.96 32.02 26.395 31.025 26.625L31.57 27.225C32.465 26.94 33.13 26.44 33.58 25.845C34 25.285 34.22 24.51 34.335 24.02C34.36 23.915 34.395 23.77 34.445 23.675ZM36.565 26.525C36.565 26.72 36.55 27.025 36.515 27.22H37.3C37.275 27.015 37.255 26.665 37.255 26.525C37.255 26.155 37.25 24.2 37.25 23.65C37.25 23.44 37.275 23.225 37.295 23.045H36.515C36.55 23.225 36.565 23.47 36.565 23.65C36.565 24.07 36.565 26.14 36.565 26.525ZM37.105 24.34V25.06C37.65 25.24 38.49 25.56 39.06 25.855L39.34 25.16C38.85 24.92 37.77 24.525 37.105 24.34Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_367_391",
    x1: 12.8152,
    y1: 0.423306,
    x2: 14.9625,
    y2: 7.76062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3089,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_367_391",
    x1: 32.3486,
    y1: -0.33816,
    x2: 28.8112,
    y2: 9.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8859,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_367_391",
    x1: 20.8852,
    y1: -1.04061,
    x2: 21.7978,
    y2: 7.6567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_367_391",
    x1: 40.8001,
    y1: -2.49336,
    x2: 19.76,
    y2: 43.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8859,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_367_391",
    x1: 16.4809,
    y1: 4.37813,
    x2: 11.4679,
    y2: 41.2861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0622507,
    stopColor: "#F5BB19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#ECC333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#E7C742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2753,
    stopColor: "#E5C948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8388,
    stopColor: "#C79000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveMoreGiftsJa);
export default __webpack_public_path__ + "static/media/live-more-gifts-ja.8e5f27c84ddb5e70f98888a9d425e406.svg";
export { ForwardRef as ReactComponent };